import { create } from 'zustand';
import { persist } from 'zustand/middleware';

export type Theme = 'light' | 'dark';

type ThemeState = { theme: Theme; toggle: () => void; set: (t: Theme) => void };

/**
 * Light by default — a broker's numbers are read in daylight far more often
 * than not. The choice is stamped on <html data-theme> by ThemeSync so the
 * whole stylesheet switches from one attribute.
 */
export const useTheme = create<ThemeState>()(
  persist(
    (set) => ({
      theme: 'light',
      toggle: () => set((s) => ({ theme: s.theme === 'light' ? 'dark' : 'light' })),
      set: (theme) => set({ theme }),
    }),
    { name: 'dabba-theme' },
  ),
);
